"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _excluded = ["title", "data", "status", "imageUrl", "buttons", "className", "style", "coverDom"];
// 在这里引入 tea-portal 组件，样式在 style/index.ts 中引入
// import Avatar from '@tencent/tea-portal/lib/Avatar';

// 在这里引入其他组件，样式在 style/index.ts 中引入
// import Button from '../Button';
var ActivityPanel = function ActivityPanel(props) {
  var title = props.title,
    data = props.data,
    status = props.status,
    imageUrl = props.imageUrl,
    buttons = props.buttons,
    className = props.className,
    style = props.style,
    coverDom = props.coverDom,
    extraProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('activity-panel');
  var classes = (0, _classnames.default)(prefixCls, !!status && !!status.type && "".concat(prefixCls, "--").concat(status.type), className);
  var _data = Array.isArray(data) ? data : [data];
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes,
    style: style
  }, extraProps), !!title && /*#__PURE__*/_react.default.createElement("h3", {
    className: "".concat(prefixCls, "__tit")
  }, title), !!data && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__data")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__data-list")
  }, _data.map(function (item, index) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "__data-item"),
      key: index
    }, item);
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__row")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__object")
  }, !!imageUrl && !coverDom && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__image"),
    style: {
      backgroundImage: "url(".concat(imageUrl, ")")
    }
  }), coverDom), !!status && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__status")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__status-icon")
  }), !!status.text && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__status-text")
  }, status.text))), !!buttons && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__btns")
  }, buttons));
};
var _default = ActivityPanel;
exports.default = _default;